export const DEFAULT_SYNC_DRIVER_DELAY_MS = 1000;
